import React from 'react';
import ReactQuill from 'react-quill';
import Dropdown from 'react-dropdown';
//import 'react-quill/dist/quill.snow.css';
//import { SketchPicker } from 'react-color';
import { PostToggleCard, SelectTemplateCard, CustomWidthCard } from '../../components';

//for load more btn and post wiget header and caption 
const toolbarModule = {
  container: [
    [{ 'align': [] }],
    ['bold', 'italic', 'underline'],
    ['link', 'clean'],
  ]
};


const modulesQuill = {
  toolbar: toolbarModule
};



//for format quill
const formatsQuill = [
  'header', 'font', 'size',
  'bold', 'italic', 'underline', 'strike', 'blockquote',
  'list', 'bullet', 'indent', 'align',
  'link', 'image', 'background', 'color',
];


const delaySlide = [
  { value: '3', label: '3s' },
  { value: '5', label: '5s' },
  { value: '10', label: '10s' },
  { value: '15', label: '15s' },
  { value: '20', label: '20s' }
];


// let fontSize = [
//   { value: '10', label: '10px' },
//   { value: '12', label: '12px' },
//   { value: '13', label: '13px' },
//   { value: '14', label: '14px' },
//   { value: '16', label: '16px' },
//   { value: '18', label: '18px' },
//   { value: '20', label: '20px' },
//   { value: '22', label: '22px' },
//   { value: '24', label: '24px' },
//   { value: '26', label: '26px' },
//   { value: '28', label: '28px' },
// ];


const ChatLayoutCard = ({
  cnf,
  handleCnfChange,
  handleEditorFocus,
  arrLylt,
  currLayoutId,
  updateLayoutById,
  handleArrayChange,
  openIconModel,
  AddfieldinArw,
  deletefieldinArw,
  fnCheckFieldIsDisplayOrNot,
  currLayout,
  widgetType
  // colorPick,
  //handleColorPicker
}) => {
  return (
    <div className="tabs-layout-content">
      <SelectTemplateCard
        arrLylt={arrLylt}
        currLayoutId={currLayoutId}
        updateLayoutById={updateLayoutById} />

      <div className="card card-editor card-template mt-15">
        <div className="card-editor-block p-0">
          <label className="card-editor-title">Header</label>
          <div className="customize-list">
            {fnCheckFieldIsDisplayOrNot('cnf.tlshdrtxt', currLayout) && cnf && cnf.tlshdrtxt != undefined &&
              <div className="editor-field-list editor-input header-editor-ckeditor editor-header-title mb-15">
                <label className="label-title">Title</label>
                <ReactQuill value={cnf.tlshdrtxt} className='editor-ckeditor-input hideEditor tlshdrtxt' modules={modulesQuill} formats={formatsQuill}
                  onChange={(newValue, delta, source) => {
                    if (source === 'user') {
                      handleCnfChange('tlshdrtxt', newValue);
                    }
                  }}
                  onFocus={() => {
                    handleEditorFocus('tlshdrtxt');
                  }} />
              </div>
            }
            {fnCheckFieldIsDisplayOrNot('cnf.tlscptntxt', currLayout) && cnf && cnf.tlscptntxt != undefined &&
              <div className="editor-field-list editor-input header-editor-ckeditor editor-header-title mb-15">
                <label className="label-title">Description</label>
                <ReactQuill value={cnf.tlscptntxt} className='editor-ckeditor-input hideEditor tlscptntxt tlsbg' modules={modulesQuill} formats={formatsQuill}
                  onChange={(newValue, delta, source) => {
                    if (source === 'user') {
                      handleCnfChange('tlscptntxt', newValue);
                    }
                  }}
                  onFocus={() => {
                    handleEditorFocus('tlscptntxt');
                  }} />
              </div>
            }
            {fnCheckFieldIsDisplayOrNot('cnf.ilg', currLayout) && cnf && cnf.ilg != undefined &&
              <div className="mb-15">
                <PostToggleCard
                  ttl={'logo display'}
                  fieldName={'ilg'}
                  value={cnf.ilg}
                  handleCnfChange={handleCnfChange} />
              </div>
            }
            {fnCheckFieldIsDisplayOrNot('cnf.tlshdricn', currLayout) && cnf && cnf.ilg == true && cnf.tlshdricn != undefined &&
              <div className="editor-field-list editor-toggle customize-dropdown customize-isaction ">
                <label className="label-title">Logo</label>
                <div className="browse-upload-part">
                  <div className="browse-upload-show" style={{ background: cnf.tlshdrbg }}>
                    <img className="browse-upload-img" src={cnf.tlshdricn} alt="image" />
                  </div>
                  <label className="editor-browse editor-browse-uploadimg" onClick={() => openIconModel('tlshdricn')}>
                    <svg htmlFor="input_file" xmlns="http://www.w3.org/2000/svg" width="13.578" height="13.438" viewBox="0 0 13.578 13.438">
                      <path id="Path_14240" data-name="Path 14240" d="M-14973.806-2683.62a.289.289,0,0,1-.274-.277v-.019a.394.394,0,0,1,.008-.057l.643-2.886,2.541,2.544-2.834.688a.327.327,0,0,1-.054.008Zm1.063-3.927,6.435-6.434,2.544,2.54-6.437,6.438Zm7.1-7.1,1.086-1.086a1.123,1.123,0,0,1,1.59,0l1.135,1.131a.872.872,0,0,1,0,1.229l-1.267,1.266Z" transform="translate(14974.58 2696.559)" fill="#3c4858" stroke="rgba(0,0,0,0)" strokeWidth="1" />
                    </svg>
                  </label>
                </div>
              </div>
            }

            {fnCheckFieldIsDisplayOrNot('cnf.tlsiicn', currLayout) && cnf && cnf.tlsiicn != undefined &&
              <PostToggleCard
                ttl={'Button logo display'}
                fieldName={'tlsiicn'}
                value={cnf.tlsiicn}
                handleCnfChange={handleCnfChange} />
            }
            {
              cnf && (cnf.tlsiicn == true || widgetType == 'story_widget') && cnf.tlsicn != undefined &&
              <div className="editor-field-list editor-toggle customize-dropdown customize-isaction">
                <label className="label-title">Button logo</label>
                <div className="browse-upload-part">
                  <div className="browse-upload-show" style={{ background: cnf.tlshdrbg }}>
                    <img className="browse-upload-img" src={cnf.tlsicn} alt="image" />
                  </div>
                  <label className="editor-browse editor-browse-uploadimg" onClick={() => openIconModel('tlsicn')}>
                    <svg htmlFor="input_file" xmlns="http://www.w3.org/2000/svg" width="13.578" height="13.438" viewBox="0 0 13.578 13.438">
                      <path id="Path_14240" data-name="Path 14240" d="M-14973.806-2683.62a.289.289,0,0,1-.274-.277v-.019a.394.394,0,0,1,.008-.057l.643-2.886,2.541,2.544-2.834.688a.327.327,0,0,1-.054.008Zm1.063-3.927,6.435-6.434,2.544,2.54-6.437,6.438Zm7.1-7.1,1.086-1.086a1.123,1.123,0,0,1,1.59,0l1.135,1.131a.872.872,0,0,1,0,1.229l-1.267,1.266Z" transform="translate(14974.58 2696.559)" fill="#3c4858" stroke="rgba(0,0,0,0)" strokeWidth="1" />
                    </svg>
                  </label>
                </div>
              </div>
            }
            {fnCheckFieldIsDisplayOrNot('cnf.stryiarw', currLayout) && cnf && cnf.stryiarw != undefined &&
              <PostToggleCard
                ttl={'Show arrow'}
                fieldName={'stryiarw'}
                value={cnf.stryiarw}
                handleCnfChange={handleCnfChange} />

              // <div className="editor-field-list editor-toggle customize-dropdown customize-showarrow">
              //   <label className="label-title">Show arrow</label>
              //   <label className="switch">
              //     <input type="checkbox" checked={cnf.stryiarw} onChange={(e) => handleCnfChange('stryiarw', e.target.checked)} />
              //     <span className="slider round"></span>
              //   </label>
              // </div>
            }
            {cnf && cnf.stryiindcr != undefined &&
              <PostToggleCard
                ttl={'Show indicator'}
                fieldName={'stryiindcr'}
                value={cnf.stryiindcr}
                handleCnfChange={handleCnfChange} />

              // <div className="editor-field-list editor-toggle customize-dropdown customize-showarrow">
              //   <label className="label-title">Show indicator</label>
              //   <label className="switch">
              //     <input type="checkbox" checked={cnf.stryiindcr} onChange={(e) => handleCnfChange('stryiindcr', e.target.checked)} />
              //     <span className="slider round"></span>
              //   </label>
              // </div>
            }
            {cnf && cnf.stryiimg != undefined &&
              <PostToggleCard
                ttl={'Show image'}
                fieldName={'stryiimg'}
                value={cnf.stryiimg}
                handleCnfChange={handleCnfChange} />

              // <div className="editor-field-list editor-toggle customize-dropdown customize-showarrow">
              //   <label className="label-title">Show image</label>
              //   <label className="switch">
              //     <input type="checkbox" checked={cnf.stryiimg} onChange={(e) => handleCnfChange('stryiimg', e.target.checked)} />
              //     <span className="slider round"></span>
              //   </label>
              // </div>
            }
            {cnf && cnf.stryilbl != undefined &&
              <PostToggleCard
                ttl={'Show label'}
                fieldName={'stryilbl'}
                value={cnf.stryilbl}
                handleCnfChange={handleCnfChange} />

              // <div className="editor-field-list editor-toggle customize-dropdown customize-showarrow">
              //   <label className="label-title">Show label</label>
              //   <label className="switch">
              //     <input type="checkbox" checked={cnf.stryilbl} onChange={(e) => handleCnfChange('stryilbl', e.target.checked)} />
              //     <span className="slider round"></span>
              //   </label>
              // </div>
            }
            {cnf && cnf.stryidt != undefined &&
              <PostToggleCard
                ttl={'Show date'}
                fieldName={'stryidt'}
                value={cnf.stryidt}
                handleCnfChange={handleCnfChange} />

              // <div className="editor-field-list editor-toggle customize-dropdown customize-showarrow">
              //   <label className="label-title">Show date</label>
              //   <label className="switch">
              //     <input type="checkbox" checked={cnf.stryidt} onChange={(e) => handleCnfChange('stryidt', e.target.checked)} />
              //     <span className="slider round"></span>
              //   </label>
              // </div>
            }
            {cnf && cnf.stryittl != undefined &&
              <PostToggleCard
                ttl={'Show title'}
                fieldName={'stryittl'}
                value={cnf.stryittl}
                handleCnfChange={handleCnfChange} />

              // <div className="editor-field-list editor-toggle customize-dropdown customize-showarrow">
              //   <label className="label-title">Show title</label>
              //   <label className="switch">
              //     <input type="checkbox" checked={cnf.stryittl} onChange={(e) => handleCnfChange('stryittl', e.target.checked)} />
              //     <span className="slider round"></span>
              //   </label>
              // </div>
            }
            {cnf && cnf.stryidsc != undefined &&
              <PostToggleCard
                ttl={'Show description'}
                fieldName={'stryidsc'}
                value={cnf.stryidsc}
                handleCnfChange={handleCnfChange} />

              // <div className="editor-field-list editor-toggle customize-dropdown customize-showarrow">
              //   <label className="label-title">Show description</label>
              //   <label className="switch">
              //     <input type="checkbox" checked={cnf.stryidsc} onChange={(e) => handleCnfChange('stryidsc', e.target.checked)} />
              //     <span className="slider round"></span>
              //   </label>
              // </div>
            }
            {fnCheckFieldIsDisplayOrNot('cnf.stryiatsld', currLayout) && cnf && cnf.stryiatsld != undefined &&
              <PostToggleCard
                ttl={'Auto slide'}
                fieldName={'stryiatsld'}
                value={cnf.stryiatsld}
                handleCnfChange={handleCnfChange} />

              // <div className="editor-field-list editor-toggle customize-dropdown customize-showarrow">
              //   <label className="label-title">Auto slide</label>
              //   <label className="switch">
              //     <input type="checkbox" checked={cnf.stryiatsld} onChange={(e) => handleCnfChange('stryiatsld', e.target.checked)} />
              //     <span className="slider round"></span>
              //   </label>
              // </div>
            }
            {fnCheckFieldIsDisplayOrNot('cnf.strydlysld', currLayout) && cnf && cnf.strydlysld != undefined && cnf.stryiatsld == true &&
              <div className="editor-dropdown customize-dropdown customize-coloms">
                <label>Delay between two slide</label>
                <Dropdown className="nf-select-dropdown nf-select-defaultdd" options={delaySlide} value={cnf.strydlysld != undefined ? cnf.strydlysld.toString() : cnf.strydlysld} onChange={(e) => handleCnfChange('strydlysld', e.value)} />
              </div>
            }
          </div>
        </div>
      </div>

      {cnf && cnf.vdurl != undefined &&
        <div className="card card-editor card-template mt-15">
          <div className="card-editor-block p-0">
            <label className="card-editor-title">YouTube video</label>
            <div className="customize-list">
              <div className="editor-field-list editor-input editor-header-title editor-toggle-fullwt">
                <label className="label-title width10x">URL</label>
                <input className='editor-input-content editor-input-fullwidth' type="text" value={cnf.vdurl} onChange={(e) => handleCnfChange('vdurl', e.target.value)}></input>
              </div>
              <div className="editor-field-list editor-toggle">
                <label className="label-title">Autoplay</label>
                <label className="switch">
                  <input type="checkbox" checked={cnf.vdiatpl} onChange={(e) => handleCnfChange('vdiatpl', e.target.checked)} />
                  <span className="slider round"></span>
                </label>
              </div>
              <div className="editor-field-list editor-toggle">
                <label className="label-title">Mute</label>
                <label className="switch">
                  <input type="checkbox" checked={cnf.vdimt} onChange={(e) => handleCnfChange('vdimt', e.target.checked)} />
                  <span className="slider round"></span>
                </label>
              </div>
              <div className="editor-field-list editor-toggle ">
                <label className="label-title">Show related video</label>
                <label className="switch">
                  <input type="checkbox" checked={cnf.vdisrltd} onChange={(e) => handleCnfChange('vdisrltd', e.target.checked)} />
                  <span className="slider round"></span>
                </label>
              </div>
            </div>
          </div>
        </div>
      }
      {cnf && cnf.tlsibtn != undefined &&
        <div className="card card-editor card-template mt-15">
          <div className="card-editor-block p-0">
            <label className="card-editor-title">CTA</label>
            <div className="customize-list ">
              <div className="editor-field-list editor-toggle editor-toggle-contentwt editor-toggle-fullwt">
                <label className="label-title">CTA</label>
                <div className="d-flex">
                  <label className="switch">
                    <input type="checkbox" checked={cnf.tlsibtn} onChange={(e) => handleCnfChange('tlsibtn', e.target.checked)} />
                    <span className="slider round"></span>
                  </label>
                </div>

                {cnf.tlsibtn == true &&
                  <div className="width10x">
                    <div className="editor-input header-editor-ckeditor editor-header-title">
                      <label className="label-title">Label</label>
                      <input className='editor-input-content editor-input-fullwidth' type="text" value={cnf.tlsbtntxt} onChange={(e) => handleCnfChange('tlsbtntxt', e.target.value)} placeholder="CTA label"></input>
                    </div>
                    {/* <div className="dd-ctalabel editor-input dd-cta-videopoup">
                  <Dropdown className="nf-select-dropdown nf-select-defaultdd" options={fontSize} value={cnf.tlsbtnfntsz != undefined ? cnf.tlsbtnfntsz.toString() : cnf.tlsbtnfntsz} onChange={(e) => handleCnfChange('tlsbtnfntsz', e.value)} />
                </div> */}
                    {widgetType == 'video_popup' ?
                      <div className='nf-group-input group-ctavideoppup mb-0'>
                        <div className="card-editor-row card-editor-lordbtn card-editor-autoscr">
                          <label className="radio label-nrm">
                            <input type='radio' value={0} checked={cnf.ctcacn == 0} onChange={(e) => handleCnfChange('ctcacn', e.target.value)} />
                            <span className="checkround"></span>
                            <span className="radio-label">Redirect to custom URL</span>
                          </label>
                          {cnf.ctcacn == 0 &&
                            <div className="mb-3">
                              <input type="text" className="nf-input nf-input-sm  nfinput-select-same select-nfinput-text" placeholder='CTA URL' value={cnf.tlsbtnrdcturl} onChange={(e) => handleCnfChange('tlsbtnrdcturl', e.target.value)} />
                            </div>
                          }
                        </div>
                        <div className="card-editor-row card-editor-lordbtn card-editor-laylod mt-3 ">
                          <label className="radio label-nrm">
                            <input type='radio' value={4} checked={cnf.ctcacn == 4} onChange={(e) => handleCnfChange('ctcacn', e.target.value)} />
                            <span className="checkround"></span>
                            <span className="radio-label"> Close the Wall </span>
                          </label>
                        </div>
                        <div className="card-editor-row card-editor-lordbtn card-editor-onbtn mt-3 ">
                          <label className="radio label-nrm">
                            <input type='radio' value={3} checked={cnf.ctcacn == 3} onChange={(e) => handleCnfChange('ctcacn', e.target.value)} />
                            <span className="checkround"></span>
                            <span className="radio-label"> None of the above </span>
                          </label>
                        </div>
                        <div className="clearfix"></div>
                      </div>
                      :
                      <div className="input-ctalabel input-ctalabel-ctaurl editor-input header-editor-ckeditor editor-header-title">
                        <label className="label-title">CTA</label>
                        <input className='editor-input-content editor-input-fullwidth' type="text" value={cnf.tlsbtnrdcturl} onChange={(e) => handleCnfChange('tlsbtnrdcturl', e.target.value)} placeholder="CTA URL"></input>
                      </div>
                    }
                    <div className="editor-field-listrm mb-0">
                      <PostToggleCard
                        ttl={'Open in same tab'}
                        fieldName={'tlsbtnclksmtb'}
                        value={cnf.tlsbtnclksmtb}
                        handleCnfChange={handleCnfChange} />
                    </div>
                    {/* <div className="editor-toggle customize-dropdown customize-opensametabe ">
                  <label className="label-title">Open in same tab</label>
                  <label className="switch">
                    <input type="checkbox" checked={cnf.tlsbtnclksmtb} onChange={(e) => handleCnfChange('tlsbtnclksmtb', e.target.checked)} />
                    <span className="slider round"></span>
                  </label>
                </div> */}
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      }

      {(fnCheckFieldIsDisplayOrNot('cnf.tlsstctbtntxt', currLayout) || fnCheckFieldIsDisplayOrNot('cnf.tlswlscrttltxt', currLayout)) &&
        <div className="card card-editor card-template mt-15">
          <div className="card-editor-block p-0">
            <label className="card-editor-title">Chat box</label>
            <div className="customize-list">
              <div className="editor-field-list editor-toggle-fullwt">
                {fnCheckFieldIsDisplayOrNot('cnf.tlsstctbtntxt', currLayout) && cnf && cnf.tlsstctbtntxt != undefined &&
                  <div className="editor-input header-editor-ckeditor editor-header-title  width10x mt-0">
                    <label className="label-title">Button text</label>
                    <ReactQuill value={cnf.tlsstctbtntxt} className='editor-ckeditor-input hideEditor tlsstctbtntxt tlshdrbg' modules={modulesQuill} formats={formatsQuill}
                      onChange={(newValue, delta, source) => {
                        if (source === 'user') {
                          handleCnfChange('tlsstctbtntxt', newValue);
                        }
                      }}
                      onFocus={() => {
                        handleEditorFocus('tlsstctbtntxt');
                      }} />
                  </div>
                }
                {fnCheckFieldIsDisplayOrNot('cnf.tlswlscrttltxt', currLayout) && cnf && cnf.tlswlscrttltxt != undefined &&
                  <div className="editor-input header-editor-ckeditor editor-header-title  width10x pb-0 mt-0">
                    <label className="label-title" style={{ marginTop: '0px' }}>Welcome message</label>
                    <ReactQuill value={cnf.tlswlscrttltxt} className='editor-ckeditor-input hideEditor tlswlscrttltxt tlsmmbrbg' modules={modulesQuill} formats={formatsQuill}
                      onChange={(newValue, delta, source) => {
                        if (source === 'user') {
                          handleCnfChange('tlswlscrttltxt', newValue);
                        }
                      }}
                      onFocus={() => {
                        handleEditorFocus('tlswlscrttltxt');
                      }} />
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      }

      {widgetType != 'tool_slider' && widgetType != 'story_widget' && cnf && cnf.tlsdtarr &&
        <div className="">
          <div className="">
            {/* <label className="card-editor-title">Contacts</label> */}
            {currLayout.ltn === 'whatsapp_chat_2' || widgetType === 'allinonechat' ?
              // <div className="customize-list">
              <div className="">
                {
                  cnf.tlsdtarr.map((val, key) => {
                    return (
                      <div key={key}>
                        <div className="card card-editor card-template mt-15">
                          <div className="card-editor-block p-0">
                            <div className="customize-list">

                              {widgetType == 'allinonechat' ?
                                <label className="card-editor-title">Account - {key + 1}</label>
                                :
                                <label className="card-editor-title">Member - {key + 1}</label>
                              }
                              <div className="editor-field-list editor-toggle-fullwt ">
                                {val.arrfl != undefined &&

                                  <div className="editor-input header-editor-ckeditor editor-header-title width10x">
                                    {widgetType == 'allinonechat' ?
                                      <label className="label-title">URL</label>
                                      :
                                      <label className="label-title">Contact Number</label>
                                    }
                                    <input type='text'
                                      className='editor-input-content editor-input-fullwidth'
                                      placeholder='Please phone number'
                                      onChange={(e) => handleArrayChange('arrfl', key, e.target.value)}
                                      value={val.arrfl} />
                                  </div>
                                }
                                {fnCheckFieldIsDisplayOrNot('val.arriimg', currLayout) && cnf && val.arriimg != undefined &&
                                  <div className="editor-toggle customize-dropdown customize-showarrow">
                                    <label className="label-title">Show only icon</label>
                                    <label className="switch">
                                      <input type="checkbox" checked={val.arriimg} onChange={(e) => handleArrayChange('arriimg', key, e.target.checked)} />
                                      <span className="slider round"></span>
                                    </label>
                                  </div>
                                }
                                {val.arrimg1 != undefined &&
                                  <div className="editor-toggle customize-dropdown customize-isaction editor-toggle-fullwt width10x my-2">
                                    {widgetType == 'allinonechat' ?
                                      <label className="label-title mb-0">Logo</label>
                                      :
                                      <label className="label-title mb-0">Member logo</label>
                                    }
                                    <div className="browse-upload-part">
                                      <div className="browse-upload-show">
                                        <img className="browse-upload-img" src={val.arrimg1} alt="image" />
                                      </div>
                                      <label className="editor-browse editor-browse-uploadimg" onClick={() => openIconModel('arrimg1', key)}>
                                        <svg htmlFor="input_file" xmlns="http://www.w3.org/2000/svg" width="13.578" height="13.438" viewBox="0 0 13.578 13.438">
                                          <path id="Path_14240" data-name="Path 14240" d="M-14973.806-2683.62a.289.289,0,0,1-.274-.277v-.019a.394.394,0,0,1,.008-.057l.643-2.886,2.541,2.544-2.834.688a.327.327,0,0,1-.054.008Zm1.063-3.927,6.435-6.434,2.544,2.54-6.437,6.438Zm7.1-7.1,1.086-1.086a1.123,1.123,0,0,1,1.59,0l1.135,1.131a.872.872,0,0,1,0,1.229l-1.267,1.266Z" transform="translate(14974.58 2696.559)" fill="#3c4858" stroke="rgba(0,0,0,0)" strokeWidth="1" />
                                        </svg>
                                      </label>
                                    </div>
                                  </div>
                                }
                                {fnCheckFieldIsDisplayOrNot('val.arrfled', currLayout) && val.arrfled != undefined &&
                                  <div className="width10x">
                                    <div className="editor-input header-editor-ckeditor editor-header-title editor-toggle-fullwt width10x">
                                      {widgetType == 'allinonechat' ?
                                        <label className="label-title">Title</label>
                                        :
                                        <label className="label-title">Name</label>
                                      }
                                      <ReactQuill value={val.arrfled} className={`${'editor-ckeditor-input hideEditor tlsmmbrbg ttl_' + key}`} modules={modulesQuill} formats={formatsQuill}
                                        onChange={(newValue, delta, source) => {
                                          if (source === 'user') {
                                            handleArrayChange('arrfled', key, newValue);
                                          }
                                        }}
                                        onFocus={() => {
                                          handleEditorFocus('ttl_' + key);
                                        }} />
                                    </div>
                                  </div>
                                }
                                {val.arrsled != undefined &&
                                  <div className="editor-input header-editor-ckeditor editor-header-title editor-toggle-fullwt width10x">
                                    <label className="label-title">Designation</label>
                                    <ReactQuill value={val.arrsled} className={`${'editor-ckeditor-input hideEditor tlsmmbrbg sdsc_' + key}`} modules={modulesQuill} formats={formatsQuill}
                                      onChange={(newValue, delta, source) => {
                                        if (source === 'user') {
                                          handleArrayChange('arrsled', key, newValue);
                                        }
                                      }}
                                      onFocus={() => {
                                        handleEditorFocus('sdsc_' + key);
                                      }} />
                                  </div>
                                }
                                {val.arrtled != undefined &&
                                  <div className="editor-input header-editor-ckeditor editor-header-title editor-header-caption">
                                    <label className="label-title">Message</label>
                                    <input type='text'
                                      className='editor-input-content editor-input-fullwidth'
                                      placeholder='Please enter the message'
                                      onChange={(e) => handleArrayChange('arrtled', key, e.target.value)}
                                      value={val.arrtled} />
                                  </div>
                                }
                                {val.idlt != false &&
                                  <div className="editor-top-delete">
                                    <span className="btn-action nf-btn  btn-delete-light  light-bg-icon btn-icon-20  tbl-action-dlt"
                                      onClick={() => deletefieldinArw(key)}>
                                      <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 176 192">
                                        <g id="Group_8307" data-name="Group 8307" transform="translate(-8)">
                                          <path id="Path_12759" data-name="Path 12759" d="M128,32V24A24.027,24.027,0,0,0,104,0H88A24.027,24.027,0,0,0,64,24v8H8V48H184V32ZM80,24a8.009,8.009,0,0,1,8-8h16a8.009,8.009,0,0,1,8,8v8H80Z" fill="#fb5360" />
                                          <path id="Path_12760" data-name="Path 12760" d="M30.467,170.651A23.976,23.976,0,0,0,54.321,192h83.358a23.976,23.976,0,0,0,23.854-21.35L174.272,56H17.728Zm87.561-99.316,15.944,1.33-8,96-15.944-1.33Zm-44.056,0,8,96-15.944,1.33-8-96Z" fill="#fb5360" />
                                        </g>
                                      </svg>
                                    </span>
                                  </div>
                                }
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })
                }
                <div className="text-center add-new-whatsapp-num mt-3">
                  <button type='button' className="nf-btn nf-btn-default" onClick={() => AddfieldinArw('chat_widget')}>
                    Add new
                  </button>
                </div>
              </div>
              :
              <div className="card card-editor card-whats-number mt-15">
                <div className="card-editor-block">
                  <div className="customize-list">
                    <label className="card-editor-title">Member</label>
                    <div className="editor-field-list editor-toggle-fullwt">
                      {
                        cnf && cnf.tlshrf != undefined &&
                        <div className="editor-input   mt-0">
                          <label className="label-title">Contact Number</label>
                          <input type='text'
                            className='editor-input-content editor-input-fullwidth'
                            placeholder='Please phone number'
                            onChange={(e) => handleCnfChange('tlshrf', e.target.value)}
                            value={cnf.tlshrf} />
                        </div>
                      }
                      {
                        cnf && cnf.tlsmsg != undefined &&
                        <div className="editor-input   mt-3">
                          <label className="label-title">Message</label>
                          <input type='text'
                            className='editor-input-content editor-input-fullwidth'
                            placeholder='Please phone number'
                            onChange={(e) => handleCnfChange('tlsmsg', e.target.value)}
                            value={cnf.tlsmsg} />
                        </div>
                      }
                    </div>
                  </div>
                </div>
              </div>
            }
          </div>
        </div>
      }

      {/* custom height / width */}
      {cnf && cnf.irspn != undefined &&
        <CustomWidthCard
          cnf={cnf}
          handleCnfChange={handleCnfChange} />
      }
    </div>
  );
};
export default ChatLayoutCard;


// WEBPACK FOOTER //
// ./src/components/Widget/ChatLayoutCard.js